import { persistentAtom } from "@nanostores/persistent"

export const $myLeadsDismissed = persistentAtom<string | null>(
  "userPrefs.myLeadsDismissed",
  null,
  {
    encode: (val: any) => val,
    decode: (val: string): string => val,
  }
)

export const setMyLeadsDismissed = () => {
  $myLeadsDismissed.set("true")
}
